const IncidentsList = async () =>
    import('../../pages/logistic-management/incidents/list/List').then((module) => ({
        Component: module.IncidentsList,
    }));

const getIncidentsRoutes = () => {
    return [
        {
            path: '/logistic-management/incidents/',
            lazy: IncidentsList,
        },
        {
            path: '/logistic-management/incidents/view/:viewId',
            lazy: IncidentsList,
        },
    ];
};

export { getIncidentsRoutes };
